export const getStackVendorSettingsUrl = (stackId: string) => `/stack/${stackId}/settings/vendor`;
